import { AxiosError } from 'axios';
import { BaseEntity } from '@ianesthesie-kit/services';
import { XOR } from '@ianesthesie-kit/core';

export type QueryResultLike<TData> = { currentData?: TData; data?: TData };

// TODO move one level up or move to kit
export const wrapError = (err: AxiosError | any) => {
  if (err.isAxiosError) {
    const e = err as AxiosError;
    return {
      error: (e.response?.data as any)?.error
    };
  }

  return {
    error: err?.message ?? err
  };
};

export type NotesHolder = BaseEntity & { notes?: string };

export type EntityUserInputWrapper<T extends BaseEntity> = {
  id: number;
} & XOR<{ entity: T }, { userDefined: string }>;
